export default "<img src=\"assets/images/loading.svg\" class=\"img-fluid w-100\" />";